import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  videoId: "",
  videoTitle: "",
};

const coursePlayerSlice = createSlice({
  name: "coursePlayer",
  initialState,
  reducers: {
    clickedVideo: (state, action) => {
      state.videoId = action.payload.id;
      state.videoTitle = action.payload.title;
    },
  },
});

export const { clickedVideo } = coursePlayerSlice.actions;
export default coursePlayerSlice.reducer;
